import { SelectAsyncInput } from '@core/components/Select';
import nbsApi from 'app/services/api/servicoFiscal/nbsApi';
import React, { useRef } from 'react';

const SelectNbs = ({ id, name, label, value, touched, error, onBlur, onChange }) => {
  const allDataRef = useRef(null);
  const PAGE_SIZE = 50;

  return (
    <SelectAsyncInput
      id={id}
      name={name}
      label={label}
      value={value}
      onChange={(event, value) => {
        onChange({
          target: {
            id,
            value,
          },
        });
      }}
      touched={touched}
      error={error}
      onBlur={onBlur}
      getOptionKey={(option) => {
        return option?.id;
      }}
      getOptionLabel={(option) => {
        return option?.codigo && option?.descricao ? `${option.codigo} - ${option.descricao}` : '';
      }}
      fetchData={async (query = '', next = 0) => {
        if (typeof query === 'object') {
          query = '';
        }

        // Se mudou a query, limpa o cache
        if (allDataRef.current && allDataRef.current.query !== query) {
          allDataRef.current = null;
        }

        // Se não tem cache, busca todos os dados da API
        if (!allDataRef.current) {
          const response = await nbsApi.pesquisarNbs({
            size: 1204, // Busca todos os dados de uma vez
            sort: 'codigo',
            page: 0,
            q: query,
          });

          allDataRef.current = {
            query,
            data: response?.data || [],
          };
        }

        // Paginação no frontend
        const allData = allDataRef.current.data;
        const startIndex = next * PAGE_SIZE;
        const endIndex = startIndex + PAGE_SIZE;
        const paginatedData = allData.slice(startIndex, endIndex);
        const hasNextPage = endIndex < allData.length;
        return {
          data: paginatedData,
          nextPage: hasNextPage ? next + 1 : null,
          totalItems: allData.length,
        };
      }}
      fetchOnFocus
    />
  );
};

export default SelectNbs;
